import { ASSETS_TYPES } from 'constants/assets'

export const LVG_GRAPH_OPTIONS = [
  { id: '0', caption: 'Tick', chart: 'tick', interval: '0', hideIf: [] },
  { id: '1', caption: '1 min', chart: 'candle', interval: '1', hideIf: ['FRIEND', 'YOLOCOASTER'] },
  { id: '2', caption: '5 mins', chart: 'candle', interval: '5', hideIf: ['FRIEND', 'YOLOCOASTER'] },
  { id: '3', caption: '15 mins', chart: 'candle', interval: '15', hideIf: ['FRIEND', 'YOLOCOASTER'] },
  { id: '4', caption: '30 mins', chart: 'candle', interval: '30', hideIf: ['FRIEND', 'YOLOCOASTER'] },
  { id: '5', caption: '1 hr', chart: 'candle', interval: '60', hideIf: ['FRIEND', 'YOLOCOASTER'] },
  {
    id: '6',
    caption: '4 hrs',
    chart: 'candle',
    interval: '240',
    hideIf: ['FRIEND', 'YOLOCOASTER', ASSETS_TYPES.STOCKS],
  },
  {
    id: '7',
    caption: '1 day',
    chart: 'candle',
    interval: '1440',
    hideIf: ['FRIEND', 'YOLOCOASTER', 'RLB/USD', ASSETS_TYPES.STOCKS],
  },
  {
    id: '8',
    caption: '7 days',
    chart: 'candle',
    interval: '10080',
    hideIf: ['FRIEND', 'YOLOCOASTER', 'RLB/USD', ASSETS_TYPES.STOCKS],
  },
  // {
  //   id: '9',
  //   caption: '15 days',
  //   chart: 'candle',
  //   interval: '21600',
  //   hideIf: ['YOLOCOASTER', ASSETS_TYPES.STOCKS, ASSETS_TYPES.MEME_COIN],
  // },
]
